/* @jsxImportSource react */
import type { Zone } from '../api/types';
import { ZONES } from '../api/types';

// ---------------------------------------------------------------------------
// Zone (execution-plane) badge — a CATEGORISATION badge, not a status pill:
// it says where a job runs, never whether the job is healthy (STYLEGUIDE §4:
// categories use the neutral `.badge` family, colours never carry status).
// ---------------------------------------------------------------------------

/** Board order + display label per zone. */
export const ZONE_META: Record<Zone, { label: string; short: string; title: string }> = {
  ru: { label: 'RU', short: 'RU', title: 'зона исполнения: RU prod кластер yc-main' },
  'kz-dr': { label: 'KZ-DR', short: 'KZ-DR', title: 'зона исполнения: KZ DR кластер kz-main' },
  'kz-vm': { label: 'KZ-VM', short: 'VM', title: 'зона исполнения: KZ VM вне k8s' },
  gh: { label: 'GitHub', short: 'GH', title: 'зона исполнения: GitHub Actions' },
  laptop: { label: 'Laptop', short: '💻', title: 'зона исполнения: ноутбук оператора' },
};

/** The fixed board/header-strip order: RU → KZ-DR → KZ-VM → GitHub → Laptop. */
export const ZONE_ORDER: readonly Zone[] = ZONES;

export function ZoneBadge({ zone }: { zone: Zone }) {
  const meta = ZONE_META[zone] ?? { label: zone, title: `зона исполнения: ${zone}` };
  return (
    <span className={`zone-badge zone-badge--${zone}`} title={meta.title}>
      {meta.label}
    </span>
  );
}
